import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/calendar.scss';
import {applyOutLineFocus} from "../Focus/utils";

const AAFModalYears = (props = {}) => {
  const classOutLineFocus = applyOutLineFocus();
  const ContentYears = () => {
        return (
            <Row className={props.device}>
                {props.options.map((y) => {
                    return (
                        <Button
                            id={`content-years-${y.id}`}
                            key={y.id}
                            activate
                            type="button"
                            className={cls('focusable', 'modal-button-years', `${classOutLineFocus}`)}
                            onClick={(e) => props.handleClose(e, props.service(y.id))}
                        >
                            {y.name}
                        </Button>
                    );
                })}
            </Row>
        );
    };
    const p = {
        alwaysEnabled: true,
        buttonsAlign: 'vertical',
        aafNewStyle: true,
        className: 'aaf-modal',
        showLogo: false,
    };
    return (
        <ModalWrapper {...p}>
            <ContentYears />
        </ModalWrapper>
    );
};

AAFModalYears.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export default withOnClose(AAFModalYears);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalYears.jsx